import { render, staticRenderFns } from "./add-products.vue?vue&type=template&id=2234e5f2&scoped=true"
import script from "./add-products.vue?vue&type=script&lang=js"
export * from "./add-products.vue?vue&type=script&lang=js"
import style0 from "./add-products.vue?vue&type=style&index=0&id=2234e5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234e5f2",
  null
  
)

export default component.exports